import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class RedirectInterceptor implements HttpInterceptor {

  constructor() {}
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (request.url.includes('identityLoginDesktopApp')) {
      const redirectUri = localStorage.getItem('redirect-uri')
      const desktopVersion = localStorage.getItem('desktop-version')
      request = request.clone({
        setHeaders: {
          'Redirect-Uri': redirectUri!,
          'X-App-Version': desktopVersion!
        }
      });
    }
    return next.handle(request);
  }
}
